import { render, staticRenderFns } from "./OrderTokens.vue?vue&type=template&id=6924243e"
import script from "./OrderTokens.vue?vue&type=script&lang=js"
export * from "./OrderTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports